// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3Boci","footer":"Form_footer__2fczw"};